import config from "config/config";
import { isFlagEnabled } from "js/utilities";

import ApplicationInsightsProvider from "./AppInsightsProvider";
import TrackingProvider from "./TrackingProvider";

// Adding this abstraction to make it easier to swap out logging/analytics tools in the future
const LoggingProvider = (props) => {
  const { portal } = props;

  if (
    isFlagEnabled("ENABLE_LOGGING") &&
    config.APP_INSIGHTS_CONNECTION_STRING
  ) {
    return (
      <ApplicationInsightsProvider config={config}>
        <TrackingProvider portal={portal}>{props.children}</TrackingProvider>
      </ApplicationInsightsProvider>
    );
  }

  return <>{props.children}</>;
};

export default LoggingProvider;
